var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "cart-line-item",
      class: _vm.line != 1 ? "cart-line-item--separated" : null,
      attrs: { "data-free-sample": _vm.freeSampleProduct }
    },
    [
      _c("div", { staticClass: "cart-line-item__image-container" }, [
        _c("img", {
          staticClass: "cart-line-item__image",
          attrs: {
            src: _vm._f("image")(_vm.item.image, "250x"),
            alt: _vm.item.product_title
          }
        })
      ]),
      _c("div", { staticClass: "cart-line-item__details" }, [
        !_vm.freeSampleProduct
          ? _c("a", {
              staticClass: "cart-line-item__product-title",
              attrs: { href: _vm.item.url },
              domProps: { innerHTML: _vm._s(_vm.item.product_title) }
            })
          : _c("p", {
              staticClass: "cart-line-item__product-title",
              domProps: { textContent: _vm._s(_vm.item.product_title) }
            }),
        _vm.item.variant_title &&
        _vm.item.variant_title.toLowerCase() != "default title"
          ? _c("p", { staticClass: "cart-line-item__variant-name" }, [
              _vm._v(_vm._s(_vm.item.variant_title))
            ])
          : _vm._e(),
        _vm.item.original_price > _vm.item.line_price
          ? _c(
              "p",
              {
                staticClass:
                  "cart-line-item__product-price cart-line-item__product-price--discounted"
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("moneyWithoutDecimals")(_vm.item.original_price)
                    )
                  )
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm._f("moneyWithoutDecimals")(_vm.item.line_price))
                  )
                ])
              ]
            )
          : !_vm.freeSampleProduct
          ? _c("p", { staticClass: "cart-line-item__product-price" }, [
              _vm._v(
                _vm._s(
                  _vm._f("moneyWithoutDecimals")(_vm.item.discounted_price)
                )
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "cart-line-item__actions" }, [
          !_vm.freeSampleProduct
            ? _c("div", { staticClass: "cart-line-item__price" }, [
                _vm._v(
                  _vm._s(_vm._f("moneyWithoutDecimals")(_vm.item.line_price))
                )
              ])
            : _c("div", { staticClass: "cart-line-item__price" }, [
                _vm._v("FREE")
              ]),
          _c("div", { staticClass: "cart-line-item__quantity" }, [
            _c("div", { staticClass: "quantity-input" }, [
              !_vm.freeSampleProduct
                ? _c(
                    "button",
                    {
                      staticClass: "quantity-input__increment",
                      attrs: {
                        "aria-label": "Increase Quantity",
                        disabled: _vm.item.line_price === 0
                      },
                      on: { click: _vm.increment }
                    },
                    [
                      _c("icon", {
                        attrs: { name: "plus", height: "16", width: "16" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.freeSampleProduct
                ? _c(
                    "button",
                    {
                      staticClass: "quantity-input__decrement",
                      attrs: {
                        "aria-label": "Decrease Quantity",
                        disabled: _vm.quantity === 1
                      },
                      on: { click: _vm.decrement }
                    },
                    [
                      _c("icon", {
                        attrs: { name: "minus", height: "16", width: "16" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("input", {
                staticClass: "quantity-input__text",
                attrs: { type: "text", readonly: "" },
                domProps: { value: _vm.thisQuantity }
              })
            ])
          ])
        ])
      ]),
      _c(
        "button",
        {
          staticClass: "button--icon cart-line-item__remove",
          on: { click: _vm.removeItem }
        },
        [
          _c("div", { staticClass: "u-sr-only" }, [_vm._v("Remove Item")]),
          _c("Icon", { attrs: { name: "close", height: "25", width: "25" } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }